import PhoneInput from "shared/components/PhoneInput";
import { connect } from "react-redux";

import {
	updatePhoneNumber,
	updateIsoCode,
	updateDialingCode,
} from "ducks/sms";

const mapStateToProps = (state) => state.sms;

const mapDispatchToProps = {
	updatePhoneNumber,
	updateIsoCode,
	updateDialingCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneInput);



// WEBPACK FOOTER //
// ./src/shared/containers/PhoneInput.js